<template>
    <div class="class-actions">
        <router-link
            :to="{ name: 'teacher_classEnrollment', params: { class_id: class_.id } }"
            class="sc-btn"
        >
            <font-awesome-icon icon="users"></font-awesome-icon>
            Students
        </router-link>
        <router-link
            :to="{ name: 'teacher_notifyClass', params: { class_id: class_.id } }"
            class="sc-btn"
        >
            <font-awesome-icon icon="bell"></font-awesome-icon>
            Notify
        </router-link>
        <router-link
            :to="{ name: 'teacher_viewAttendance', params: { class_id: class_.id } }"
            class="sc-btn"
        >
            <font-awesome-icon icon="clipboard-list"></font-awesome-icon>
            Attendance
        </router-link>
        <!--
        <router-link
            :to="{ name: 'teacher_gradeOverview', params: { class_id: class_.id } }"
            class="sc-btn"
        >
            <svg height="16" width="16" viewBox="0 0 32 32">
                <circle cx="16" cy="16" r="15" stroke="white" stroke-width="3" fill="transparent" />
                <text text-anchor="middle" x="16" y="20" fill="white" font-size="1.13rem" font-style="italic">A+</text>
                Sorry, your browser does not support inline SVG.  
            </svg>
            Grades
        </router-link>
        -->
        <!--
        <button
            class="sc-btn"
            variant="primary"
        >
            <svg height="16" width="16" viewBox="0 0 32 32">
            <circle cx="16" cy="16" r="15" stroke="white" stroke-width="2" fill="transparent" />
            <text text-anchor="middle" x="16" y="20" fill="white" font-size="1.13em" font-style="italic">A+</text>
            Sorry, your browser does not support inline SVG.  
            </svg>
            Grades
        </button>
        <button
            class="sc-btn"
        >
            <font-awesome-icon icon="smile"></font-awesome-icon>
            Behavior
        </button>
        -->
    </div>
</template>
<script>
export default {
    props: {
        class_: Object
    }
}
</script>
<style scoped>
    .class-actions {
        padding: 0;
        display: grid;
        gap: 0.25rem;
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    }
    .class-actions a, .class-actions button {
        min-width: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .class-actions svg {
        margin-right: 1rem;
        display: block;
    }
</style>